export const KEYBOARD_INTERFACE_TYPE = 'KEYBOARD';
export const SEQUENCER_INTERFACE_TYPE = 'SEQUENCER';
